//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  resource,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { map, Subject, takeUntil } from "rxjs";

// local imports
import { CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";
import { Messenger } from "@app/shared";
import { NavigationService } from "@app/core";

@Component({
  selector: "project-property",
  standalone: false,
  templateUrl: "./project-property.component.html",
  styleUrl: "./project-property.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectPropertyComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private catalogStateService = inject(CatalogStateService);
  private navigationService = inject(NavigationService);
  private messenger = inject(Messenger);

  private readonly destroying$ = new Subject<void>();

  public projectId = toSignal(
     this.route.paramMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.ID)))
  );

  private programId = toSignal(
    this.route.queryParamMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID)))
  );

  public projectPropertyResource = resource({
    request: () => ({
      id: this.projectId(),
      programId: this.programId(),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getProjectProperty(
        request.id,
        request.programId
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }

      return property;
    },
  });


  public ngOnInit(): void {
    this.catalogStateService.initialize(this.route);

    this.route.queryParamMap.pipe(
      takeUntil(this.destroying$)
    ).subscribe((params) => {
      const projectId = params.get(CatalogCommonConstants.ROUTE_PARAMS.PROJECT_ID);

      const programId = params.get(CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID);

      if (!projectId && !programId) {
        this.navigateToListPage();
      } else if(!projectId){
        this.navigationService.back();
      }
    });
  }

  public navigateToListPage() {
    this.router.navigate(["/catalog"]);
  }


  ngOnDestroy(): void {
    this.messenger.unsubscribeByOwner(this);
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }
}